export default __webpack_public_path__ + "static/media/ok_off.f02752b4.png";